import React from 'react'
import styled from '@emotion/styled'

import { fontSize3XSmall, fontFamilyOpenSans, highlightBlueBase } from '../../constants/principles'
import { breakpoints } from '../../constants'

export default ({ isDesktop, kbbUrl = 'https://www.kbb.com' }) => (
  <StyledDivDealerBoost data-testid = {`oc-dealer-boost-policy`} isDesktop={isDesktop} data-nosnippet>
    {'1 Dealer inspection required. If the information you provide about the vehicle differs from the dealer inspection, the Offer amount may be decreased. Kelley Blue Book does not redeem Offers, purchase vehicles or own/operate Participating Dealers. Dealers pay a fee to participate in the Kelley Blue Book Instant Cash Offer program. See '}
    <StyledA target="_blank" href={`${kbbUrl}/company/terms-of-service/#termsAndConditions`}>
      Program Terms and Conditions
    </StyledA>
    {' previously agreed to by you.\n'}
    <br />
    {'2 Dealer Boost amounts are determined and provided solely by, and can only be redeemed through, that Participating Dealer. Kelley Blue Book and its affiliates are not responsible for Offer adjustments, Dealer Boosts, or if a Participating Dealer won’t accept your vehicle.'}
  </StyledDivDealerBoost>
)

const StyledA = styled.a`
  color: ${highlightBlueBase};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`

const StyledDivDealerBoost = styled.div`
  font-size: ${fontSize3XSmall};
  font-family: ${fontFamilyOpenSans};
  line-height: 17px;
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    width: 1024px;
  }
  margin: 16px 16px 16px 16px;
`
